(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["size-guide"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.sg-inner').forEach(function (inner) {
      /* Tab switching */
      inner.querySelectorAll('.sg-tab').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.dataset.tab;
          inner.querySelectorAll('.sg-tab').forEach(function (b) {
            b.classList.toggle('sg-tab--active', b === btn);
            b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
          });
          inner.querySelectorAll('.sg-panel').forEach(function (panel) {
            var active = panel.dataset.panel === target;
            panel.classList.toggle('sg-panel--active', active);
            if (active) panel.removeAttribute('hidden');
            else panel.setAttribute('hidden', '');
          });
        });
      });

      /* cm / in conversion */
      function cmToIn(raw) {
        if (raw.indexOf('-') !== -1) {
          return raw.split('-').map(function (v) {
            return (Math.round(parseFloat(v) * 0.394 * 10) / 10).toFixed(1);
          }).join('-');
        }
        return (Math.round(parseFloat(raw) * 0.394 * 10) / 10).toFixed(1);
      }

      inner.querySelectorAll('.sg-unit').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var unit = btn.dataset.unit;
          inner.querySelectorAll('.sg-unit').forEach(function (b) {
            b.classList.toggle('sg-unit--active', b === btn);
          });
          inner.querySelectorAll('td[data-cm]').forEach(function (td) {
            td.textContent = unit === 'in' ? cmToIn(td.dataset.cm) : td.dataset.cm;
          });
          inner.querySelectorAll('.sg-th-u').forEach(function (th) {
            th.textContent = unit === 'in' ? th.dataset.in : th.dataset.cm;
          });
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
